export default {
  name: 'Aswitch',
  props: {
    value: { type: null, default: null },
    disabled: { type: Boolean, default: () => false },
    width: { type: Number, default: () => 40 },
    activeIconClass: { type: String, default: () => '' },
    inactiveIconClass: { type: String, default: () => '' },
    activeText: { type: String, default: () => '开' },
    inactiveText: { type: String, default: () => '关' },
    activeValue: { type: Boolean | Number | String, default: () => 1 },
    inactiveValue: { type: Boolean | Number | String, default: () => 0 },
    activeColor: { type: String, default: () => null },
    inactiveColor: { type: String, default: () => '' },
    validateEvent: { type: Boolean, default: () => false },
  },
  data() {
    return ({
      model: this.value,
    });
  },
  watch: {
    value(value) {
      this.model = value;
    },
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    },
    focus(value) {
      this.$emit('focus', value);
    },
    change(value) {
      this.$emit('change', value);
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <el-switch
        v-model={this.model}
        disabled={this.disabled}
        width={this.width}
        active-icon-class={this.activeIconClass}
        inactive-icon-class={this.inactiveIconClass}
        active-text={this.activeText}
        inactive-text={this.inactiveText}
        active-value={this.activeValue}
        inactive-value={this.inactiveValue}
        active-color={this.activeColor}
        inactive-color={this.inactiveColor}
        validate-event={this.validateEvent}
        on-change={this.change}
        on-input={this.input}
        on-focus={this.focus}
        on={this.$listeners}
        {...{ attrs }}
      />
    );
  }
}